module.exports = __webpack_public_path__ + "img/marker_five_cyan1.e8877fc0.png";